/* Order tracking page: shows the tracking number from ?n=. If the carrier can be detected
   (tracking-detect.js, bundled open-source rules, no network calls) the number links to the
   carrier's tracking page; otherwise it is shown as plain text. */
if (!customElements.get('order-track')) {
  const NAMES = { usps: 'USPS', ups: 'UPS', fedex: 'FedEx', dhl: 'DHL', amazon: 'Amazon', ontrac: 'OnTrac', s10: 'Postal service' };

  customElements.define('order-track', class extends HTMLElement {
    connectedCallback() {
      const params = new URLSearchParams(location.search);
      const raw = params.get('n') || params.get('number') || '';
      const number = raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
      if (number.length < 6 || number.length > 40) { this.showForm(raw); return; }
      const run = () => this.show(number);
      window.knivsTracking ? run() : window.addEventListener('load', run, { once: true });
    }

    showForm(prefill) {
      const form = this.querySelector('[data-form]');
      form.hidden = false;
      if (prefill) form.querySelector('input').value = prefill;
    }

    show(number) {
      const card = this.querySelector('[data-result]');
      const carrier = this.querySelector('[data-carrier]');
      const slot = this.querySelector('[data-number]');
      const spaced = number.replace(/(.{4})(?=.)/g, '$1 ');

      let hit;
      try { hit = window.knivsTracking && window.knivsTracking.getTracking(number); } catch (e) { hit = undefined; }

      if (hit && hit.trackingUrl) {
        const name = NAMES[(hit.courier.code || '').toLowerCase()] || hit.courier.name;
        const link = document.createElement('a');
        link.href = hit.trackingUrl.replace('%s', encodeURIComponent(number));
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = spaced;
        slot.replaceChildren(link);
        carrier.textContent = name;
        carrier.hidden = false;
      } else {
        slot.textContent = spaced;
      }
      card.hidden = false;
    }
  });
}
